<template>
    <div class="color-picker-main row" v-click-outside="hideColor" v-bind:class="{ active: displayColor }">
        <p>{{newValue || '--'}}</p>

        <section class="vue-color">
            <chrome v-if="displayColor" v-model="pickedColor"/>
        </section>

        <div class="selected-color row align-middle" v-on:click="displayColor = !displayColor" :style="{backgroundColor: newValue}"></div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import { Chrome } from 'vue-color';
import ClickOutside from 'vue-click-outside';// Note ClickOutside: https://www.npmjs.com/package/vue-click-outside

export default {
    name: 'colorpicker',
    mixins: [
        Default
    ],
    props: ['name', 'placeholder', 'value'],
    components: {
        'chrome': Chrome
    },
    directives: {
        ClickOutside
    },
    data() {
        return {
            newValue: '',
            displayColor: false,
            pickedColor: '#000000'
        };
    },
    created() {
        this.newValue = this.value;
        this.pickedColor = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            if (newVal[0] !== '#')
                newVal = '#' + newVal;

            this.$emit('input', newVal);
        },
        pickedColor: function(newVal, oldVal) {
            if (newVal instanceof Object)
                this.newValue = newVal.hex;
        }
    },
    methods: {
        hideColor: function() {
            this.displayColor = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    $border-color: #e8ebf0;
    $height: 2.5em;

    .color-picker-main {
        position: relative;
        vertical-align: baseline;
        line-height: 40px;
        width: 8em;
        height: $height;
        background-color: #f2f5fa;
        border: 1px solid $border-color;
        border-radius: 5px;
        margin: 0;

        &.active {
            border-color: #52d261;
        }

        .vue-color {
            position: absolute;
            top: -20px;
            left: 205px;
            z-index: 999;
        }

        & > p {
            color: #5a5a5a;
            width: 6em;
            margin: auto auto auto .5em;
        }

        .selected-color {
            position: absolute;
            margin: 0;
            border: 3px solid black;
            border-radius: 4px;
            width: calc(#{$height} - 3px);
            height: calc(#{$height} - 3px);
            cursor: pointer;
            top: 0;
            right: 0;
        }
    }
</style>